// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file common/common_errors.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file common/common_errors.proto.
 */
export const file_common_common_errors: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Chpjb21tb24vY29tbW9uX2Vycm9ycy5wcm90bxIUY29tLmdlbS5iZmYuY29udHJhY3QiFAoSTWlzc2luZ1BhcmFtc0Vycm9yIhIKEFRvb01hbnlEYXRhRXJyb3JCGAoUY29tLmdlbS5iZmYuY29udHJhY3RQAWIGcHJvdG8z'
  );

/**
 * @generated from message com.gem.bff.contract.MissingParamsError
 */
export type MissingParamsError = Message<'com.gem.bff.contract.MissingParamsError'> & {};

/**
 * Describes the message com.gem.bff.contract.MissingParamsError.
 * Use `create(MissingParamsErrorSchema)` to create a new message.
 */
export const MissingParamsErrorSchema: GenMessage<MissingParamsError> =
  /*@__PURE__*/
  messageDesc(file_common_common_errors, 0);

/**
 * @generated from message com.gem.bff.contract.TooManyDataError
 */
export type TooManyDataError = Message<'com.gem.bff.contract.TooManyDataError'> & {};

/**
 * Describes the message com.gem.bff.contract.TooManyDataError.
 * Use `create(TooManyDataErrorSchema)` to create a new message.
 */
export const TooManyDataErrorSchema: GenMessage<TooManyDataError> =
  /*@__PURE__*/
  messageDesc(file_common_common_errors, 1);
